import React, { Component } from "react";

/**
 * StaticHtmlAdapter - Renders static HTML/content blocks.
 */
export default class StaticHtmlAdapter extends Component {
  render() {
    const { config } = this.props;
    const customProps = config.customProps || {};
    const htmlContent = customProps.html || "";

    return (
      <div
        className="static-html-widget"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    );
  }
}
